import { Spin, Typography } from 'antd'
import { titleCase } from '../lib/helpers';
import { useEffect, useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import { getUSerCredits } from '../lib/getUserCredits';
import { getUserCreditsAp } from '../lib/getUserCreditsAp';
import defaultProfilePicutre from '../assets/apollo/defaultProfilePicture.png'
const { Title } = Typography;

interface TitleProps {
    title: string;
    subtitle?:React.ReactNode;
    apolloKey?:number;
    sufix?:React.ReactNode
}

const HeaderSection = ({ title,subtitle,apolloKey,sufix }: TitleProps) => {
    const [userCredits, setUserCredits] = useState(-2)
    const [apolloCredits, setApolloCredits] = useState(-2)
    const [username, setUsername] = useState("");
    const auth = useAuth()
    const currentAuthenticatedUser = async () => {
        try {
            const user = auth.username
            return user;
        } catch (err) {
            console.log(err);
            return null;
        }
    };

    useEffect(()=>{
        getUSerCredits().then(value =>{
            setUserCredits(value)
        })
    },[])
    useEffect(()=>{
        getUserCreditsAp().then(value =>{
            setApolloCredits(value)
        })
    },[apolloKey])

    useEffect(() => {
        const fetchUser = async () => {
            const user = await currentAuthenticatedUser();
            const name = auth.name;
            if (user) {
                setUsername(name || 'Convidado');
            }
        }
        fetchUser();
    }, []);

    return (
        <div className="header-section">
            <div style={{width:'100%'}}>
                <div style={{ width:'100%', display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                    {
                    <div className='header-subsection'>  
                        <h2>
                            <div className='header-credits-wrapper'>
                                {userCredits === -2 ? (
                                    <Spin style={{ marginLeft: 8 }} />
                                ) : userCredits === -1 ? (
                                    <p className='credits-value-header'>Ilimitado</p>
                                ) : (
                                    <p className='credits-value-header' >{userCredits}</p>
                                )}
                                <p className='credits-description-header'><b>Créditos</b> <br/> de prospecção </p>
                            </div>
                        </h2>
                        {apolloCredits === null ? <></> :
                        <h2>
                            <div className='header-credits-wrapper'>
                            {apolloCredits === -2 ? (
                                <Spin style={{ marginLeft: 8 }} />
                            ) : apolloCredits === -1 ? (
                                <p className='credits-value-header'>Ilimitado</p>
                            ) : (
                                <p className='credits-value-header' >{apolloCredits}</p>
                            )}
                            <p  className='credits-description-header'><b>Créditos</b> <br/> de enriquecimento </p>
                            </div>
                        </h2>
                        }
                    </div>
                    }
                    <div className='header-subsection'>
                        <h2 className='header-username'><img src={defaultProfilePicutre} className='header-picture'/>{titleCase(username)}</h2>
                    </div>
                </div>
                <Title style={{ marginTop:'1em', color:'#141774', display:'flex', flexDirection:'row',alignItems:'center'}}>{title}<span style={{marginLeft:'0.5em'}}>{sufix}</span></Title>
                <span style={{ color:'#494CA8'}}>{subtitle}</span>
            </div>
        </div>
    );
};

export default HeaderSection;